/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import AssignUserRoletags from "../../../../components/Settings/User/AssignUserRoletags";
import ConfirmUserDetails from "../../../../components/Settings/User/ConfirmUserDetails";
import UserDetailsInput from "../../../../components/Settings/User/UserDetailsInput";
import VerifyUserPan from "../../../../components/Settings/User/VerifyUserPan";
import { getEntities } from "../../../../redux/features/Settings/Management/entities";
import {
  AddUserTag,
  assignRole,
  createUser,
  getAllRoles,
  getUsers,
} from "../../../../redux/features/Settings/Management/Users";
import {
  resetBeneData,
  resetPANVerification,
  verifyThisPAN,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";

const CreateUsers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { verifyPAN, verifyPANisLoading } = useSelector(
    (state) => state.verify,
  );
  const { createUserLoading } = useSelector((state) => state.users);

  const [activeStep, setActiveStep] = useState(0);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [aliasValidation, setAliasValidation] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);
  const [userIdValidation, setUserIdValidation] = useState(false);
  const [roleAssigned, setRoleAssigned] = useState(false);
  const [tagsAssigned, setTagsAssigned] = useState(false);
  const [gradeOption, setGradeOption] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const [newTags, setNewTags] = useState([]);
  const [AllRoles, setAllRoles] = useState([]);
  const [newRoles, setNewRoles] = useState([]);

  const enitityID = JSON.parse(sessionStorage.getItem("response"))?.entity
    ?.entity_id;

  let queryParams = {
    entity_id: enitityID,
  };

  const handleuserAll = async () => {
    try {
      const [usersRes, rolesRes, entityRes] = await Promise.all([
        dispatch(getUsers({ page_no: 1, page_size: 50 })),
        dispatch(getAllRoles()),
        dispatch(getEntities(queryParams)),
      ]);

      if (rolesRes?.payload?.status) {
        await setAllRoles(
          rolesRes.payload.roles.map(({ role_name, role_id }) => ({
            selected: true,
            value: role_name,
            type: "Available",
            role_id: role_id,
          })),
        );
      }

      if (usersRes?.payload?.status) {
        await setAllTags(
          usersRes.payload.available_tags.map((tag) => ({
            selected: true,
            value: tag,
            type: "Available",
          })),
        );
      }

      if (entityRes?.payload?.status) {
        await setGradeOption(entityRes?.payload?.entities[0]?.grades);
      }
    } catch (error) {
      return error;
    }
  };

  const [userPayload, setUserPayload] = useState({
    panNumber: "",
    grade: "",
    contact_no: "",
    entity_Id: enitityID,
  });

  const scrollIt = useRef(null);

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (!Validation?.alphanumericRegex.test(inputPan)) {
      return;
    }

    if (inputPan.length > 10) {
      return;
    }
    if (
      !Validation.panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
    } else if (inputPan.length === 10) {
      dispatch(verifyThisPAN({ pan_number: inputPan, showToast: false }));
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
    }

    setUserPayload({ ...userPayload, panNumber: inputPan });
  };

  const handleNext = async () => {
    if (activeStep === 3 && !createUserLoading) {
      let data = await dispatch(createUser({ userPayload }));

      if (createUser.fulfilled.match(data)) {
        if (newTags?.length > 0) {
          let tags = newTags.map((val) => val.value);

          dispatch(
            AddUserTag({
              user_id: [data.payload.employees[0]?.id],
              tags,
            }),
          );
        }

        dispatch(assignRole({ newRoles, id: data.payload.employees[0]?.id }));

        navigate(
          `/settings/users/create_user/success/${data.payload.employees[0]?.id}`,
          {
            state: {
              user: {
                ...data.payload,
                pan: userPayload?.panNumber,
                newRoles: newRoles,
                newTags: newTags,
              },
            },
          },
        );
      } else if (createUser.rejected.match(data)) {
        navigate(`/settings/users/create_user/error`, {
          state: {
            error: data.payload,
          },
        });
      }

      return;
    }

    setActiveStep(
      (prevActiveStep) => prevActiveStep + GlobalConfiguration.lengthCheckOne,
    );
    setDirection("next");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 500);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate("/settings/user_view_all");
      return;
    }
    setButtonDisabled(true);
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 500);
  };

  const steps = [
    "PAN details",
    "Contact details",
    "Roles and tags",
    "Confirm and create user",
  ];

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <VerifyUserPan
            verifyPANisLoading={verifyPANisLoading}
            panNumber={userPayload.panNumber}
            panDetails={verifyPAN?.pan_details}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
          />
        );
      case 1:
        return (
          <UserDetailsInput
            userPayload={userPayload}
            selectedValue={selectedValue}
            setUserPayload={setUserPayload}
            setSelectedValue={setSelectedValue}
            verifyPAN={verifyPAN}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            activeStep={activeStep}
            BenEnableNextButton={BenEnableNextButton}
            contactNumberValidation={contactNumberValidation}
            setContactNumberValidation={setContactNumberValidation}
            emailValidation={emailValidation}
            setEmailValidation={setEmailValidation}
            aliasValidation={aliasValidation}
            setAliasValidation={setAliasValidation}
            passwordValidation={passwordValidation}
            setPasswordValidation={setPasswordValidation}
            userIdValidation={userIdValidation}
            setUserIdValidation={setUserIdValidation}
            gradeOption={gradeOption}
          />
        );
      case 2:
        return (
          <AssignUserRoletags
            roleAssigned={roleAssigned}
            setRoleAssigned={setRoleAssigned}
            tagsAssigned={tagsAssigned}
            AllTags={AllTags}
            setAllTags={setAllTags}
            setTagsAssigned={setTagsAssigned}
            newTags={newTags}
            setNewTags={setNewTags}
            AllRoles={AllRoles}
            setAllRoles={setAllRoles}
            newRoles={newRoles}
            setNewRoles={setNewRoles}
          />
        );
      case 3:
        return (
          <ConfirmUserDetails
            userPayload={userPayload}
            newRoles={newRoles}
            newTags={newTags}
          />
        );

      default:
        return null;
    }
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[2],
    },
    {
      previousText: "Previous",
      nextText: "Confirm",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: createUserLoading,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[3],
      nextLoaderNeeded: true,
    },
  ];

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      BenEnableNextButton(!verifiedPan);
    } else if (
      activeStep === GlobalConfiguration.lengthCheckOne &&
      emailValidation &&
      contactNumberValidation &&
      accountNameValidation &&
      userPayload?.grade?.length > GlobalConfiguration.lengthCheckZero &&
      userPayload?.password?.length > GlobalConfiguration.lengthCheckTwo &&
      userPayload?.user_id?.length &&
      userPayload?.alias?.length
    ) {
      BenEnableNextButton(false);
    } else if (
      activeStep === GlobalConfiguration.lengthCheckTwo &&
      newRoles.length > GlobalConfiguration.lengthCheckZero
    ) {
      BenEnableNextButton(false);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      BenEnableNextButton(false);
    } else {
      BenEnableNextButton(true);
    }
  }, [
    activeStep,
    verifiedPan,
    emailValidation,
    contactNumberValidation,
    accountNameValidation,
    userPayload?.grade,
    userPayload?.password,
    userPayload?.user_id,
    userPayload?.alias,
    newRoles,
  ]);

  useEffect(() => {
    handleuserAll();
  }, []);

  useEffect(() => {
    if (!verifyPANisLoading) {
      if (verifyPAN?.status === true) {
        setVerifiedPan(true);

        setUserPayload((prev) => ({
          ...prev,
          legalName: verifyPAN?.pan_details?.full_name,
          account_name: verifyPAN?.pan_details?.full_name,
        }));
      } else if (
        verifyPAN?.status === false &&
        userPayload?.panNumber.length === GlobalConfiguration.panLength
      ) {
        setVerifiedPan(false);
      }
    }
  }, [verifyPAN]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  return (
    <div className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto h-full-height">
      <div className="w-full Qmd:block hidden lg:bg-transparent bg-primary-nav">
        <div className="h-navbar-breadcrumb-height my-margin-sm Qmd:my-margin-base"></div>
      </div>

      <div className="flex justify-center items-end w-screen Qmd:relative fixed bottom-bottom-base left-left-base z-z-index-loader min-h-stepper-height">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      <div className="flex items-center w-width-full bg-primary-nav p-padding-sm fixed left-left-base top-top-base z-z-index-header h-mobile-create-header Qsmd:hidden">
        <div
          className="cursor-pointer"
          onClick={() => {
            navigate("/settings/user_view_all");
          }}
        >
          <SVGComponent
            url={ICONS?.ARROW_LEFT_WHITE}
            height={"var(--icon-sm)"}
            width={"var(--icon-sm)"}
            color={"var(--text-primary)"}
          />
        </div>

        <div className=" flex flex-col pl-padding-md">
          <p className=" text-font-md font-sans text-text-primary"> User</p>
          {activeStep === GlobalConfiguration.lengthCheckZero && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Enter PAN details
            </p>
          )}
          {activeStep === GlobalConfiguration.lengthCheckOne && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Enter Contact details
            </p>
          )}
          {activeStep === GlobalConfiguration.lengthCheckTwo && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Roles and tags
            </p>
          )}
          {activeStep === GlobalConfiguration.lengthCheckThree && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Confirm and create user
            </p>
          )}
        </div>
      </div>

      <>
        <div
          className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
          ref={scrollIt}
        >
          <div className="h-mobile-create-header flex-shrink-0 w-width-full Qsmd:hidden block"></div>
          <div
            className={`w-width-full overflow-auto Qsmd:pt-padding-lg Qsmd:pb-padding-md pt-padding-base h-height-full ${
              activeStep === GlobalConfiguration.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClass
            }`}
            style={{
              scrollbarWidth: "none",
            }}
          >
            {renderCreateAccount()}
          </div>
        </div>
      </>

      <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
    </div>
  );
};

export default CreateUsers;
